<template>
  <div class="col-3 position-absolute top-0 end-0 z-index--200">
    <div class="ratio ratio-1x1">
      <img
        src="../../assets/images/landing/1.png"
        alt="background-symbol-image"
      />
    </div>
  </div>
  <div class="col-3 position-absolute top-45 start-0 z-index--200">
    <div class="ratio ratio-1891x2633">
      <img
        src="../../assets/images/price/2.png"
        alt="background-symbol-image"
      />
    </div>
  </div>
  <div class="col-5 position-absolute bottom-0 start-0 z-index--200">
    <div class="ratio ratio-1x1">
      <img src="../../assets/images/blog/3.svg" alt="background-symbol-image" />
    </div>
  </div>
  <div class="position-relative">
    <single-blog-long-article :long-article="longArticle" />
    <related-blog-posts-section :category-id="longArticle.blog_category_id" />
  </div>
</template>
<script>
export default {
  name: "BlogSingle",
};
</script>
<script setup>
import { blogApi } from "@/main.ts";
import { ref, onMounted } from "vue";
import { useRoute } from "vue-router";
import SingleBlogLongArticle from "@/components/blog/show/SingleBlogLongArticle";
import RelatedBlogPostsSection from "@/components/blog/show/RelatedBlogPostsSection";
import { useClientStore } from "@/store/ClientStore";
import { storeToRefs } from "pinia";
import { watch } from "vue";

const clientStore = useClientStore();
const { pageLoading } = storeToRefs(clientStore);
const route = useRoute();
const longArticle = ref({});

onMounted(() => {
  loadLongArticle();
});

watch(route.params.blogId, () => loadLongArticle());

const loadLongArticle = async () => {
  try {
    pageLoading.value = true;
    longArticle.value = (
      await blogApi.get(`blog-posts/${route.params.blogId}`)
    ).data.data;
  } catch (e) {
    console.log(e);
  } finally {
    pageLoading.value = false;
  }
};
</script>

<style scoped></style>
